import {
    AccordionDetails,
    AccordionSummary,
    Accordion,
    IconButton,
    LinearProgress,
    Button
} from '@mui/material';
import { ExpandMore, PanoramaFishEye, TaskAlt } from '@mui/icons-material';
import useSetupProgress from './hooks/useSetupProgress';
import { Body3, Body2, H6, Body4 } from "../../../../../themes/typography"

export default function SetupProcess() {
    const {
        expandSetupProgress,
        expandEventDetails,
        handleSetupProgressExpand,
        handleEventDetailsExpand,
        tasks,
        progress,
        expandBankDetails,
        handleBankDetailsExpand,
        expandTaxInvoice,
        handleTaxInvoiceExpand
    } = useSetupProgress();

    const expandStates = {
        1: { expanded: expandEventDetails, onExpand: handleEventDetailsExpand },
        3: { expanded: expandBankDetails, onExpand: handleBankDetailsExpand },
        4: { expanded: expandTaxInvoice, onExpand: handleTaxInvoiceExpand }
    };

    return (
        <div className='setup-process-component'>
            <Accordion
                expandSetupProgress={expandSetupProgress}
                sx={{
                    background: 'var(--gradient-overlay-bg-color)',
                    borderRadius: '1rem !important',
                    border: '1px solid var(--divider-color)',
                    boxShadow: 'none',
                }}
            >
                <AccordionSummary
                    sx={{
                        cursor: 'context-menu !important',
                        padding: '8px 20px',
                        '& .MuiAccordionSummary-content.Mui-expanded': {
                            margin: '1rem 0'
                        }
                    }}
                >
                    <div className='event-setup-process-container'>

                        <div className='setup-process-title-container'>
                            <div className='setup-process-title'>
                                <H6 fontWeight={600}>
                                    Setup Progress
                                </H6>
                                <Body3>
                                    Complete these items to publish your event
                                </Body3>
                            </div>
                            <div className='setup-process-accrodion-expand'>
                                <IconButton
                                    onClick={handleSetupProgressExpand}
                                >
                                    {expandSetupProgress ? <ExpandMore sx={{ transform: 'rotate(180deg)' }} /> : <ExpandMore />}
                                </IconButton>
                            </div>
                        </div>

                        <div className='setup-process-bar-container'>

                            <div className='setup-completed-value-container'>
                                <Body3 fontWeight={400}>
                                    {progress}% Completed
                                </Body3>

                                {/* <Body3>
                                    {dummyTasks?.filter((t) => t.completed).length ?? 0} of {dummyTasks?.length ?? 0}
                                </Body3> */}
                            </div>

                            <div className='linear-setup-progress'>
                                <LinearProgress
                                    value={progress}
                                    variant="determinate"
                                    sx={{
                                        height: '6px',
                                        borderRadius: '1rem',
                                        backgroundColor: 'var(--warning-light-bg-color)',
                                        '& .MuiLinearProgress-bar1Determinate': {
                                            backgroundColor: 'var(--secondary-color) !important',
                                        }
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </AccordionSummary>
                <AccordionDetails>

                    <div className='setup-process-details-container'>
                        <div className='setup-process-details-container'>
                            {tasks.map((task) => {
                                if (task.isExpandable) {
                                    const { expanded, onExpand } = expandStates[task.id];
                                    return (
                                        <ExpandableTask
                                            key={task.id}
                                            task={task}
                                            expanded={expanded}
                                            onExpand={onExpand}
                                        />
                                    );
                                }
                                return <TaskItem key={task.id} task={task} />;
                            })}
                        </div>
                    </div>

                </AccordionDetails>
            </Accordion>
        </div>
    );
}

function TaskItem({ task }) {
    return (
        <div className='setup-process-task-item'>
            <div className='task-name-icon'>
                {task.completed
                    ? <TaskAlt color="success" />
                    : <PanoramaFishEye color="white" />
                }
                <div className='task-name-tooltip'>
                    <Body2>{task.title}</Body2>
                    {task.tooltip && (
                        <Body4>
                            {task.tooltip}
                        </Body4>
                    )}
                </div>
            </div>
            <div className='task-name-action-btn'>
                <Button
                    variant='text'
                    onClick={task?.completed ? task?.onEdit : task?.onConfig}
                    disableTouchRipple
                    disabled={task?.disableBtn}
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: 'transparent',
                            color: 'var(--secondary-color)'
                        }
                    }}
                >
                    {task?.completed ? 'Edit' : 'Configure'}
                </Button>
            </div>
        </div>
    );
}

function ExpandableTask({ task, expanded, onExpand }) {
    return (
        <Accordion
            expanded={expanded}
            sx={{
                background: expanded ? 'var(--gradient-overlay-bg-color)' : 'transparent',
                borderRadius: '1rem !important',
                boxShadow: 'none',
                width: '100%',
                '&.MuiAccordion-root.Mui-expanded': {
                    margin: '0 !important'
                }
            }}
        >
            <AccordionSummary
                sx={{
                    cursor: 'context-menu !important',
                    padding: '0',
                    '&.Mui-expanded': {
                        minHeight: '0'
                    },
                    '& .MuiAccordionSummary-content': {
                        margin: '0'
                    },
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                        margin: '0'
                    }
                }}
            >
                <div className='setup-process-task-item'>
                    <div className='task-name-icon'>
                        {task.completed
                            ? <TaskAlt color="success" />
                            : <PanoramaFishEye color="white" />
                        }
                        <Body2>
                            {task.title}
                        </Body2>
                    </div>
                    <div className='setup-process-accrodion-expand'>
                        <IconButton
                            onClick={onExpand}
                        >
                            {expanded
                                ? <ExpandMore sx={{ transform: 'rotate(180deg)', fontSize: '1.72rem' }} />
                                : <ExpandMore sx={{ fontSize: '1.72rem' }} />
                            }
                        </IconButton>
                    </div>
                </div>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: '1rem' }}>
                <div className='setup-process-details-container'>
                    {task.subTasks?.map((subTask) => (
                        <TaskItem key={subTask.id} task={subTask} />
                    ))}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}